"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ts_validators_1 = require("ts-validators");
const controlIsLegacy_1 = __importDefault(require("../shared/controlIsLegacy"));
const ControlRenderer_1 = __importDefault(require("../ControlRenderer"));
const AppRenderControl_1 = __importDefault(require("../components/AppRenderControl"));
const controlChildrenArrayToComponent = (controls) => {
    if (!controls || !(0, ts_validators_1.valueIsArray)(controls)) {
        return null;
    }
    return controls.map((control) => {
        if ((0, controlIsLegacy_1.default)(control)) {
            return (react_1.default.createElement(ControlRenderer_1.default, { key: control.id, control: control }));
        }
        return react_1.default.createElement(AppRenderControl_1.default, { key: control, controlId: control });
    });
};
exports.default = controlChildrenArrayToComponent;
